<script lang="ts">
    export let stepIdx: number;

    let sliderWidth: number;
    let offset = -1;

    $: if (sliderWidth != null) {
        offset = sliderWidth * stepIdx;
    }
</script>

<div
    class="slider flex size-full items-stretch transition-[margin-left] duration-300 ease-in-out"
    style="--offset:-{offset}px;"
    bind:clientWidth={sliderWidth}
>
    <slot />
</div>

<style>
    .slider {
        margin-left: var(--offset);
    }
</style>
